import React, { useState, useEffect } from "react";
import aoIcon from "../../images/AOIcon.svg";
import { Button, Form, Input, Checkbox, message } from "antd";
import "./Login.css";

import { useNavigate } from "react-router-dom";
import { AuthService } from "../../Services/AuthService";
import { useUser } from "../../Context/UserContext";

const Login: React.FC = () => {
  const { setCurrentUser, isAuthenticated, isSubAdmin, isSuperAdmin } = useUser();
  const [btnLoading, setBtnLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  useEffect(() => {
    // Dynamic page title updates for Production Live Console
    document.title = "AO Console - Secure Administrator Portal";
    
    // Add meta description for SEO / portal clarity
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute(
      'content', 
      'Secure login portal for Acting Office Console administrators. Access practice management dashboards, invoices, submissions, and metrics.'
    );
  }, []);

  const handleLoginSubmit = async (values: any) => {
    setBtnLoading(true);
    try {
      const user: any = await AuthService.login(values.username.trim(), values.password.trim());
      if (user?.token != null) {
        setCurrentUser(user);
        if (isAuthenticated()) {
          const userRoles: string[] = user.roles || (user.role ? [user.role] : []);
          const isSupportOnly = userRoles.some((r: string) =>
            ["SUPPORTUSER", "SUPPORTMANAGER", "SUPPORTADMIN", "SupportUser", "SupportManager", "SupportAdmin"].includes(r)
          ) && !userRoles.includes("SUPERADMIN") && !userRoles.includes("SUBADMIN") && !userRoles.includes("SuperAdmin") && !userRoles.includes("SubAdmin");

          if (isSupportOnly) {
            navigate("/tickets");
          } else {
            navigate("/dashboard");
          }
        }
      }
    } catch (error: any) {
      setBtnLoading(false);
      message.error(error?.message || "Invalid username or password");
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <main className="login-page">
      <div className="login-card">
        <div className="login-logo-wrap">
          <div className="login-header-brand">
            <img src={aoIcon} className="login-logo" alt="AO Logo" />
            <div className="login-brand-info">
              <span className="login-brand-title">Acting Office</span>
              <span className="login-brand-badge">Console Portal</span>
            </div>
          </div>
        </div>

        <Form
          form={form}
          name="login"
          initialValues={{ remember: true }}
          onFinish={handleLoginSubmit}
          layout="vertical"
          id="ao-login-form"
        >
          <div className="login-label">Username</div>
          <Form.Item
            name="username"
            rules={[{ required: true, message: "Please enter username!" }]}
            className="login-form-item"
          >
            <Input
              id="ao-login-username"
              onKeyPress={(e) => e.key === ' ' && e.preventDefault()}
              placeholder="Please enter your username/email"
              className="loginInput"
              autoComplete="username"
              autoFocus
            />
          </Form.Item>

          <div className="login-label">Password</div>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please enter password!" }]}
            className="login-form-item"
          >
            <Input.Password
              id="ao-login-password"
              className="loginInput"
              autoComplete="current-password"
              placeholder="Please enter your password"
              onKeyPress={(e) => e.key === ' ' && e.preventDefault()}
            />
          </Form.Item>

          {/* <div className="login-options-row">
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox className="login-checkbox">Remember me?</Checkbox>
            </Form.Item>
            <a href="#" className="forgot-password-link" onClick={(e) => e.preventDefault()}>
              Forgot password?
            </a>
          </div> */}

          <Form.Item className="login-btn-item" style={{ marginTop: "24px" }}>
            <Button
              id="ao-login-submit-btn"
              type="primary"
              htmlType="submit"
              loading={btnLoading}
              className="login-btn"
              block
            >
              Log in
            </Button>
          </Form.Item>
        </Form>

        <div className="login-description-box">
          Authorised administrator access only. All activities are monitored.
        </div>
      </div>
    </main>
  );
};

export default Login;




